<!-- eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text -->
<script setup>
/* eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text */
import { ref } from 'vue';
import Dialog from 'dashboard/components-next/dialog/Dialog.vue';

defineProps({
  title: { type: String, default: 'imóvel' },
  code: { type: String, default: '-' },
  currentPrice: { type: String, default: '' },
  newPrice: { type: String, default: '' },
  isLoading: { type: Boolean, default: false },
  disableConfirm: { type: Boolean, default: false },
});

const emit = defineEmits(['confirm', 'close']);

const dialogRef = ref(null);

defineExpose({
  open: () => dialogRef.value?.open(),
  close: () => dialogRef.value?.close(),
});
</script>

<template>
  <Dialog
    ref="dialogRef"
    title="Atualizar no Midas"
    confirm-button-label="Confirmar atualização"
    cancel-button-label="Cancelar"
    :is-loading="isLoading"
    :disable-confirm-button="disableConfirm"
    @confirm="emit('confirm')"
    @close="emit('close')"
  >
    <div class="space-y-4 text-[13px] text-lais-text">
      <p class="text-lais-text-muted">
        Confirme para executar o fluxo de mudanca de valor no Midas para o
        imovel selecionado.
      </p>
      <div class="rounded-lais border border-lais-border bg-lais-bg-page p-4">
        <p class="text-[11px] font-semibold uppercase text-lais-text-muted">
          Imovel
        </p>
        <p class="mt-1 font-semibold text-lais-text">
          {{ title }}
        </p>
        <dl class="mt-4 grid gap-3 sm:grid-cols-3">
          <div>
            <dt class="text-[11px] font-semibold text-lais-text-muted">
              Codigo Midas
            </dt>
            <dd class="mt-1 font-semibold text-lais-text">
              {{ code }}
            </dd>
          </div>
          <div>
            <dt class="text-[11px] font-semibold text-lais-text-muted">
              Valor atual
            </dt>
            <dd class="mt-1 font-semibold text-lais-text">
              {{ currentPrice }}
            </dd>
          </div>
          <div>
            <dt class="text-[11px] font-semibold text-lais-text-muted">
              Novo valor
            </dt>
            <dd class="mt-1 font-semibold text-lais-primary">
              {{ newPrice }}
            </dd>
          </div>
        </dl>
      </div>
    </div>
  </Dialog>
</template>
